import React, { useEffect, useState } from 'react';
import ReactSelect from 'react-select';
 import { confirm } from "react-confirm-box";
import { useMemo } from 'react';
import { useEntityCrud } from '../../hooks/useEntityCrud';

const Form = ({ formik, inputTypeList, path, setPath,
    groupList, setGroupList, activeList,
    businessList, orgAddress, isEditMode,
    setOrgAddress, serviceList,
    setServiceList, discountsList }) => {


    const { readDataByFilter: readDataGroup } = useEntityCrud('Group/GetAllGroups')
    const { readDataByFilter: readDataService } = useEntityCrud('Service/GetAllServices')

    const businessAll = useMemo(() => businessList?.map(item => ({ value: item.id, label: item.title })));

    const groupAll = useMemo(() => groupList?.map(item => ({ value: item.id, label: item.title })))

    const serviceAll = useMemo(() => serviceList?.map(item => ({ value: item.id, label: item.title })))

    const inputTypeListAll = useMemo(() => inputTypeList?.map(item => ({ value: item.id, label: item.title , type:item.type})))


    useEffect(() => {
        const postedData = {
            buisnessId: orgAddress?.buisnessId.value,
        };
        readDataGroup(postedData).then(res => {
            if (res.data.result.length > 0) {
                setGroupList(res.data.result)
            }
        });
    }, [businessList, orgAddress?.buisnessId?.value])


    useEffect(() => {
        const postedData = {
            groupId: orgAddress?.groupId.value,
        };
        readDataService(postedData).then(res => {
            if (res.data.result.length > 0) {
                setServiceList(res.data.result)
            }
        });
    }, [groupList, orgAddress?.groupId?.value])


    const handleChangeBusiness = (value) => {
        setOrgAddress(prevState => ({ ...prevState, serviceId: "" }))
        setOrgAddress(prevState => ({ ...prevState, groupId: "" }))
        setOrgAddress(prevState => ({ ...prevState, buisnessId: value }))
    }

    const handleChangeGroup = (value) => {
        setOrgAddress(prevState => ({ ...prevState, serviceId: "" }))
        setOrgAddress(prevState => ({ ...prevState, groupId: value }))
    }


    const handleChangeService = (value) => {
        setOrgAddress(prevState => ({ ...prevState, serviceId: value }))
    }

    const [sh, setSh] = useState(false);

    useEffect(() => {
        if (path?.length === 0)
            setPath([{
                id: 0,
                type: "",
                title: ""
            },])
    }, [path])

    function handleAddPath() {
        setSh(true);
        setPath(data => [...data, {
            id: 0,
            type: "",
            title: ""
        }
        ])
    }

    const options = {
        render: (message, onConfirm, onCancel) => {
            return (
                <>
                    <h4>{message} </h4>
                    <br />
                    <button className='btn btn-primary mx-1 px-4' onClick={onConfirm}> بله</button>
                    <button className='btn btn-secondary  px-4 mx-1' onClick={onCancel}> خیر</button>
                </>
            );
        }
    };

    const handleRemovePoint = async (index) => {
        const result = await confirm("آیا از حذف رکورد مورد نظر اطمینان دارید ؟ ", options);
        if (result) {
            setPath(lastPath => lastPath.filter((item, i) => index !== i))
            return;
        }
    };

    function handleChange(value, key, index) {
         
        setPath(list => list.map((item, i) => {
            if (i === index) {
                 
                return {
                    ...item,
                    [key]: value,
                }
            } else return item;
        }))
    }


    return (
        <form onSubmit={formik.handleSubmit}>
            <div className="row">
                {isEditMode === false && <div className="col-md-4" style={{ position: "relative", zIndex: "10" }}>
                    <label>
                        کسب و کار
                    </label>
                    <ReactSelect label="   کسب و کار"
                        required
                        options={businessAll}
                        value={orgAddress?.buisnessId}
                        onChange={handleChangeBusiness}
                        placeholder="انتخاب کنید"
                        name="buisnessId"
                    />
                </div>}
                {isEditMode === false && <div className="col-md-4">
                    <label>
                        گروه
                    </label>
                    <ReactSelect label="گروه"
                        required
                        options={groupAll}
                        placeholder="انتخاب کنید"
                        name="groupId"
                        value={orgAddress?.groupId}
                        onChange={handleChangeGroup}
                    />
                </div>}
                {isEditMode === false && <div className="col-md-4">
                    <label>
                        سرویس
                    </label>
                    <ReactSelect label="سرویس"
                        required
                        options={serviceAll}
                        placeholder="انتخاب کنید"
                        name="serviceId"
                        value={orgAddress?.serviceId}
                        onChange={handleChangeService}
                    />
                </div>}
            </div>
            <div className="row mt-4 pt-4" style={{marginRight:"3px"}}>
                <div className='col-md-8 thisHide' >
                    <div className='d-flex align-items-end mobileThem'>
                        <div style={{ flex: "1" }}>
                            {<div class="card-status card-status-right bg-red br-bs-7 br-ts-7" ></div>}
                            <div >
                                <label>
                                    فیلدهای درخواستی
                                </label>
                                {path?.map((item, index) => {
                                    return <div className='d-flex align-items-center' key={index}>
                                        <div className="col-md-12">

                                            <div className="row m-0">
                                                <div className="col-md-6 form-group">
                                                    <label> عنوان </label>
                                                    <input type="text" className="form-control "
                                                        onChange={(e) => handleChange(e.target.value , "title" , index)}
                                                        value={item.title} />
                                                </div>
                                                <div className="col-md-6 form-group">
                                                    <label> نوع </label>
                                                    <select type="text" value={item.type} className="form-control" required
                                                        onChange={(e) => handleChange(e.target.value , "type" , index)} placeholder="Title">
                                                        <option></option>
                                                        {inputTypeListAll.map(item => <option key={item.value}>{item.type}</option>)}
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                        <a className="btn btn-danger text-light btnMob px-3"
                                            style={{ marginTop: "16px" }}
                                            onClick={() => handleRemovePoint(index)}>
                                            <i className='fa fa-minus'
                                                style={{ fontSize: "12px" }}></i>
                                        </a>
                                        <hr />
                                    </div>;
                                }
                                )}
                            </div>
                        </div>
                        <a className="btn btn-primary px-4 text-light btnMob"
                            style={{ marginRight: "5%", marginBottom: "15px" }}
                            onClick={handleAddPath}> <i className='fa fa-plus'
                                style={{ fontSize: "12px" }}></i></a>
                    </div>
                </div>
            </div>

            <div className='mx-auto text-center my-4 py-4'>
                <button className="btn btn-success ">ذخیره اطلاعات</button>
            </div>
        </form >
    );
}

export default Form;